/**
 * FAQ Page
 *
 * Content lives in data/content/faq.ts (#2212 — shared with the native
 * FAQ screen).
 */

import PageLayout from '../components/PageLayout';
import ContentDocView from '../components/ContentDocView';
import { FAQ_DOC } from '../data/content/faq';

export default function FaqPage() {
  return (
    <PageLayout maxWidth="standard" title="FAQ">
      <ContentDocView doc={FAQ_DOC} />
    </PageLayout>
  );
}
